class ListNavigator {
    constructor() {}

    build(selector) {
        this.list = document.querySelector(selector)
        this.currentIndex = 0

        if (this.list.children) {
            this.addIndexes()

            this.list.addEventListener('mouseover', (event) => {
                this.select(event.target)
            })

            this.list.addEventListener('click', (event) => {
                this.select(event.target, true)
            })

            this.list.children[0].classList.add('active')
        }
    }

    addIndexes() {
        let y = -1
        let row = -1
        let column = -1
        let index = -1

        for (let element of this.list.children) {
            let rect = element.getBoundingClientRect()

            if (y < rect.y) {
                y = rect.y
                column = -1
                row++
            }

            index++
            column++

            element.dataset['row'] = row
            element.dataset['column'] = column
            element.dataset['index'] = index
        }
    }

    select(element, picked = false) {
        this.deactivateElements()

        if (element && element.getAttribute('role') == 'option') {
            this.currentIndex = parseInt(element.dataset.index, 10)

            element.classList.add('active')

            this.onSelectedCallback(element, picked)
        }
    }

    onSelected(callback) {
        this.onSelectedCallback = callback
    }

    selectCurrent() {
        this.select(this.current())
    }

    deactivateElements() {
        for (let element of this.list.querySelectorAll('.active')) {
            element.classList.remove('active')
        }
    }

    current() {
        return this.list.children[this.currentIndex]
    }

    bindKeys(event) {
        switch (event.keyCode) {
            case 37:
                this.left(event)
                break
            case 38:
                this.up(event)
                break
            case 39:
                this.right(event)
                break
            case 40:
                this.down(event)
                break
        }
    }

    left(event) {
        event.preventDefault()

        if (this.currentIndex > 0) {
            this.select(this.list.children[this.currentIndex - 1])
        }
    }

    right(event) {
        event.preventDefault()

        if (this.currentIndex < this.list.children.length - 1) {
            this.select(this.list.children[this.currentIndex + 1])
        }
    }

    up(event) {
        event.preventDefault()

        let data = this.current().dataset

        this.selectClosestElementInColumn(`[data-row="${parseInt(data.row) - 1}"]`, parseInt(data.column))
    }

    down(event) {
        event.preventDefault()

        let data = this.current().dataset

        this.selectClosestElementInColumn(`[data-row="${parseInt(data.row) + 1}"]`, parseInt(data.column))
    }

    selectClosestElementInColumn(selector, column) {
        let elements = this.list.querySelectorAll(selector)

        if (elements.length === 0) {
            return
        }

        for (let i = column; i >= 0; i--) {
            if (elements[i]) {
                return this.select(elements[i])
            }
        }
    }
}

export default ListNavigator